import { RequestOptions, ResponseContentType, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
  ) {
    this.baseUrl = environment.unileverApiHost;
  }

  get<T>(uri: string, baseUrl = this.baseUrl) {
    return this.http.get<T>(`${baseUrl}/${uri}`, { headers: this.generateHeaders() });
  }

  download<T>(uri: string, baseUrl = this.baseUrl) {
    let header = this.generateHeaders();
    const options = {
      responseType: 'blob' as 'json',
      headers: header
    };
    return this.http.get<T>(
        `${baseUrl}/${uri}`, 
        options
    );
  }

  post<T>(uri: string, data?: any, baseUrl = this.baseUrl) {
    return this.http.post<T>(`${baseUrl}/${uri}`, data, { headers: this.generateHeaders() });
  }
  
  postCustom<T>(uri: string, data?: any, baseUrl = this.baseUrl, headerqq?: any) {
    let headerTTmp =this.generateHeaders(headerqq);
    
    return this.http.post<T>(`${baseUrl}/${uri}`, data, {
      headers: headerTTmp,
      
    });
  }
  
  getByParams(uri: string, params: HttpParams, baseUrl = this.baseUrl) {
    return this.http.get(`${baseUrl}/${uri}`, {
      headers: this.generateHeaders(),
      params: params
    });
  }

  put(uri: string, data?: any, baseUrl = this.baseUrl) {
    return this.http.put(`${baseUrl}/${uri}`, data, { headers: this.generateHeaders() });
  }

  putCustomResType(uri: string, data?: any, baseUrl = this.baseUrl, reponseType?: any) {
    return this.http.put(`${baseUrl}/${uri}`, data, { headers: this.generateHeaders(), responseType: reponseType });
  }

  delete(uri: string, baseUrl = this.baseUrl) {
    return this.http.delete(`${baseUrl}/${uri}`, { headers: this.generateHeaders() });
  }

  postFile(uri: string, data?: any, baseUrl = this.baseUrl) {
    return this.http.post(baseUrl + uri, data, { headers: this.generateHeaders() });
  }

  private generateHeaders = (headerCustom?: any) => {
    return new HttpHeaders({...environment.requestHeader, ...headerCustom });
  };
}
